import type { Review, ReviewSorting, VerificationStatus } from './review';

export interface ProductReviewsWidget {
  id: string;
  overall_rating: number;
  reviews_count: number;
  images: string[];
  sort_by: ReviewSorting;
  rating: {
    five_stars: {
      rating: number;
      count: number;
    };
    four_stars: {
      rating: number;
      count: number;
    };
    three_stars: {
      rating: number;
      count: number;
    };
    two_stars: {
      rating: number;
      count: number;
    };
    one_star: {
      rating: number;
      count: number;
    };
  };
  reviews: Review[];
}

export interface Filters {
  has_images: boolean | null;
  product_ids: number[];
  rating_from: number | null;
  rating_to: number | null;
  verified: VerificationStatus | null;
}

type RatingDetailsItem = {
  rating: number;
  count: number;
};

export interface RatingDetails {
  five_stars: RatingDetailsItem;
  four_stars: RatingDetailsItem;
  three_stars: RatingDetailsItem;
  two_stars: RatingDetailsItem;
  one_star: RatingDetailsItem;
}

export const RatingDetailsKeyToValue: {
  [K in keyof RatingDetails]: number;
} = {
  five_stars: 5,
  four_stars: 4,
  three_stars: 3,
  two_stars: 2,
  one_star: 1,
};

type WidgetComponents = {
  images: boolean | null;
  rating_details: boolean | null;
};

export interface WidgetRequest {
  filters: Filters;
  components: WidgetComponents;
  locale?: string;
  page: number;
  count: number;
  sort: ReviewSorting;
}

export interface WidgetResponseMeta extends WidgetRequest {
  images: string[];
  limit: number | null;
  rating_details: RatingDetails | null;
  total: number;
}

export const initialWidgetRequest: WidgetRequest = {
  components: {
    images: null,
    rating_details: null,
  },
  filters: {
    has_images: null,
    product_ids: [],
    rating_from: 1,
    rating_to: 5,
    verified: null,
  },
  count: 1,
  page: 1,
  sort: 'DATE_DESC',
};

export interface WidgetResponse {
  items: Review[];
  meta: WidgetResponseMeta;
}
